import { render, staticRenderFns } from "./GalleryManageServiceList.vue?vue&type=template&id=84460e30&scoped=true"
import script from "./GalleryManageServiceList.vue?vue&type=script&lang=js"
export * from "./GalleryManageServiceList.vue?vue&type=script&lang=js"
import style0 from "./GalleryManageServiceList.vue?vue&type=style&index=0&id=84460e30&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84460e30",
  null
  
)

export default component.exports